import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Scale, X, ArrowRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { useCompare } from '@/contexts/CompareContext';

const CompareBar = () => {
  const { t } = useTranslation();
  const { compareList, removeFromCompare, clearCompare, compareCount } = useCompare();

  if (compareCount === 0) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        className="fixed bottom-0 left-0 right-0 bg-[#121212] border-t border-[#D4AF37]/30 p-4 z-50 shadow-2xl"
        data-testid="compare-bar"
      >
        <div className="container-custom flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Selected Properties */}
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2 text-[#D4AF37]">
              <Scale size={20} />
              <span className="font-medium">{compareCount}/3</span>
            </div>
            
            <div className="flex gap-2">
              {compareList.map(property => (
                <div 
                  key={property.id}
                  className="relative group"
                >
                  <div className="w-16 h-16 rounded overflow-hidden border border-white/10">
                    <img 
                      src={property.images?.[0]?.url || 'https://via.placeholder.com/64'} 
                      alt={property.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <button
                    onClick={() => removeFromCompare(property.id)}
                    className="absolute -top-2 -right-2 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity"
                  >
                    <X size={12} />
                  </button>
                </div>
              ))}
              
              {/* Empty slots */}
              {Array.from({ length: 3 - compareCount }).map((_, i) => (
                <div 
                  key={`empty-${i}`}
                  className="w-16 h-16 rounded border-2 border-dashed border-white/20 flex items-center justify-center"
                >
                  <span className="text-white/30 text-xs">+</span>
                </div>
              ))}
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center gap-3">
            <Button
              variant="ghost"
              onClick={clearCompare}
              className="text-[#A3A3A3] hover:text-white"
            >
              {t('compare.clear', 'Limpiar')}
            </Button>
            
            <Link to="/comparar">
              <Button 
                className="bg-[#D4AF37] text-black hover:bg-[#FFE182]"
                disabled={compareCount < 2}
              >
                {t('compare.compareNow', 'Comparar')}
                <ArrowRight size={16} className="ml-2" />
              </Button>
            </Link>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default CompareBar;
